module.exports = __webpack_public_path__ + "static/media/1998_GDP_totalRate.039607c4.png";